const applicationCode = (xmlElement) => {
    const ApplicationCode = xmlElement.getElementsByTagName("cb:ApplicationCodes")[0];
    const ProviderApplicationNo = ApplicationCode.attributes?.ProviderApplicationNo?.value ?? ''
    const CBContractCode = ApplicationCode.attributes?.CBContractCode?.value ?? ''

    // application
    const Application = xmlElement.getElementsByTagName("cb:Application")[0];
    const ContractTypeCode = Application.attributes?.ContractTypeCode?.value ?? ''
    const ContractPhase = Application.attributes?.ContractPhase?.value ?? ''
    const ContractRequestDate = Application.attributes?.ContractRequestDate?.value ?? ''
    const Currency = Application.attributes?.Currency?.value ?? ''
    const Credit = Application.getElementsByTagName('cb:Credit')[0];
    const ApplicationAmount = Credit.attributes?.ApplicationAmount?.value ?? ''
    // end application

    // ApplicationDesc
    const ApplicationDesc = xmlElement.getElementsByTagName("cb:ApplicationDesc")[0];
    const ContractTypeDesc = ApplicationDesc.attributes?.ContractTypeDesc?.value ?? ''
    const ContractPhaseDesc = ApplicationDesc.attributes?.ContractPhaseDesc?.value ?? ''
    const CurrencyDesc = ApplicationDesc.attributes?.CurrencyDesc?.value ?? ''
    // end ApplicationDesc

    // Link
    const Link = xmlElement.getElementsByTagName("cb:Link")[0];
    const Role = Link.attributes?.Role?.value ?? ''
    // end Link

    // LinkDesc
    const LinkDesc = xmlElement.getElementsByTagName("cb:LinkDesc")[0];
    const RoleDesc = LinkDesc.attributes?.RoleDesc?.value ?? ''
    // end LinkDesc
    const result = {
        ProviderApplicationNo,
        CBContractCode,
        ContractTypeCode,
        ContractPhase,
        ContractRequestDate,
        Currency,
        ApplicationAmount,
        ContractTypeDesc,
        ContractPhaseDesc,
        CurrencyDesc,
        Role,
        RoleDesc,
    }

    return result;
}

export default applicationCode;